// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogProductsBlock_container__wdV1Z","useFade-fadeIn":"BlogProductsBlock_useFade-fadeIn__u4Sh1","useFade-fadeOut":"BlogProductsBlock_useFade-fadeOut__Sy3FF"};